// --- START OF FILE src/pages/MainScreen.jsx ---

import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { useNavigate, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { db } from '../firebase';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import AboutPage from '../pages/AboutUs';
import ContactPage from '../pages/ContactUs';
import SettingsPage from '../pages/Settings';
// import RhosonicsDashboard from '../dashboards/RhosonicsDashboard'; // Ya no se importa directamente aquí
import DashboardWrapper from '../components/DashboardWrapper'; // MODIFICACIÓN: Importar DashboardWrapper
import NotificationToast from '../components/NotificationToast';
import { notificationManager } from '../utils/NotificationManager';
import '../styles/MainScreen.css';

function MainScreen({ onLogout, user }) {
  const { t } = useTranslation();
  const [dashboards, setDashboards] = useState([]);
  const [activeNotification, setActiveNotification] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    // Configurar listener para notificaciones en primer plano
    notificationManager.setOnMessageListener((payload) => {
      console.log("Notificación recibida en MainScreen:", payload);
      setActiveNotification(payload.notification);
    });

    return () => notificationManager.setOnMessageListener(null);
  }, []);

  // Efecto para el flasheo del título de la pestaña
  useEffect(() => {
    let intervalId;
    const originalTitle = document.title;

    if (activeNotification) {
      let showLabel = true;
      intervalId = setInterval(() => {
        document.title = showLabel ? `⚠️ ${t('alertTitle', 'ALERTA')} - ResEYE` : originalTitle;
        showLabel = !showLabel;
      }, 1000);
    } else {
      document.title = originalTitle;
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      document.title = originalTitle;
    };
  }, [activeNotification, t]);

  const handleClearNotification = () => {
    setActiveNotification(null);
    notificationManager.stopAlarm();
  };

  useEffect(() => {
    const obtenerDashboardsDelUsuario = async () => {
      if (!user?.uid) return;

      const refPath = `users/${user.uid}/dashboards`;
      try {
        const snapshot = await getDocs(collection(db, refPath));
        const dashboardsCompletos = [];

        for (const docRef of snapshot.docs) {
          const dashboardId = docRef.id;
          const dashboardBaseSnap = await getDoc(doc(db, 'dashboards', dashboardId));
          if (dashboardBaseSnap.exists()) {
            dashboardsCompletos.push({ id: dashboardId, ...dashboardBaseSnap.data() });
          } else {
            console.warn(`Dashboard base con ID ${dashboardId} no encontrado en la colección 'dashboards'.`);
          }
        }
        setDashboards(dashboardsCompletos);

        if (location.pathname === '/') {
          if (dashboardsCompletos.length > 0 && dashboardsCompletos[0]?.id) {
            navigate(`/dashboard/${dashboardsCompletos[0].id}`, { replace: true });
          }
        }
      } catch (error) {
        console.error("Error obteniendo dashboards del usuario:", error);
      }
    };

    obtenerDashboardsDelUsuario();
  }, [user, location.pathname, navigate]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="main-screen-container">
      <Sidebar
        dashboards={dashboards}
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className="main-content-area">
        <Topbar
          user={user}
          onLogout={onLogout}
          onToggleSidebar={toggleSidebar}
        />
        <main className="page-content">
          <Routes>
            {/* MODIFICACIÓN: Ruta de dashboard ahora usa DashboardWrapper */}
            <Route path="/dashboard/:dashboardIdParams" element={<DashboardWrapper />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/settings" element={<SettingsPage user={user} />} />
            <Route
              path="/"
              element={
                dashboards.length > 0 && dashboards[0]?.id ? (
                  <Navigate to={`/dashboard/${dashboards[0].id}`} replace />
                ) : (
                  <div style={{ padding: '20px', color: 'var(--text-secondary)' }}>
                    <h2 style={{ color: 'var(--text-primary)' }}>{t('welcomeNoDashboardsTitle')}</h2>
                    <p>{t('welcomeNoDashboardsMessage')}</p>
                  </div>
                )
              }
            />
            <Route path="*" element={
              <div style={{ padding: '20px', color: 'var(--text-secondary)' }}>
                <h2 style={{ color: 'var(--text-primary)' }}>{t('pageNotFoundTitle')}</h2>
                <p>{t('pageNotFoundMessage')}</p>
              </div>
            } />
          </Routes>
        </main>
      </div>

      {isSidebarOpen && <div className="sidebar-backdrop" onClick={toggleSidebar}></div>}

      <NotificationToast
        notification={activeNotification}
        onClear={handleClearNotification}
        t={t}
      />
    </div>
  );
}

export default MainScreen;
// v1.0.0
// --- END OF FILE src/pages/MainScreen.jsx ---